import { useState, useEffect, useContext } 	from "react";
import { Box, Card, CardContent, CircularProgress, Stack, Typography } from "@mui/material"
import TrendingUp from "@mui/icons-material/TrendingUp";

import DashboardContext from "../context";
import TrendingDown from "@mui/icons-material/TrendingDown";
import { formatCurrency } from "../../../common/Helper";

const TrendingIcon = (props) => {
	if (props.value >= 0) {
		return <TrendingUp {...props}/>
	}
	else {
		return <TrendingDown {...props}/>
	}
}

const SummaryCard = () => {
	const {portfolio, dividends, exchangeRates}			= useContext(DashboardContext)

	const [currentPosition, setCurrentPosition]			= useState()
	const [currentReturn, setCurrentReturn]				= useState()
	const [isLoading, setIsLoading]						= useState(true)

	const [totalEarnings, setTotalEarnings] 			= useState()
	const [monthlyEarnings, setMonthlyEarnings]	 		= useState()
	const [calculatingEarnings, setCalculingEarnings]	= useState(true)

	const currencyFormat = new Intl.NumberFormat('pt-BR', {
		style : "currency",
		currency : "BRL",
		maximumFractionDigits: 0, 
		minimumFractionDigits: 0, 
	})

	useEffect(() => {
		if ( portfolio ) {
			const current 			= portfolio.reduce((acc, p) => acc + parseFloat(p.currentValue),0)
			const original 			= portfolio.reduce((acc, p) => acc + parseFloat(p.cost),0)
			const historicReturn	= ((current/original) - 1) * 100 || 0
			setCurrentPosition(current.toFixed(0))
			setCurrentReturn(historicReturn.toFixed(2))
			setIsLoading(false)
		}


	}, [portfolio])
	
	useEffect(() => {
		if (dividends && exchangeRates) {
			const currentExchangeRate	= exchangeRates.find(er => er.symbol === 'USDBRL')?.price
			const currentEarnings		= dividends.reduce((acc, p) => acc + p.earnings * (p.market !== 'BR' ? currentExchangeRate : 1), 0)
			const averageEarnings		= currentEarnings / 12

			setTotalEarnings(currentEarnings)
			setMonthlyEarnings(averageEarnings)
			setCalculingEarnings(false)
		}
	}, [dividends, exchangeRates])

	return (
		<Card sx={{height:'100%'}}>
			<CardContent sx={{height: '100%'}}>
				<Stack direction={'column'} spacing={1} height={'90%'} display={'flex'} alignItems={'stretch'} justifyContent={'center'}>
					<Box border={'1px solid rgba(0, 0, 0, 0.12)'} borderRadius={1} padding={1} height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
						<Stack>
							<Typography variant="h6" align="center"> Posição Atual </Typography>
							{isLoading ? (
								<Box display={'flex'} justifyContent={'center'}>
									<CircularProgress size={'1.5rem'} sx={{display: 'flex', padding: 1}}/>
								</Box>
							):(								
								<>
								<Typography variant="h6" align="center" color="success.main">{currencyFormat.format(currentPosition)}</Typography>
								<Box display='flex' justifyContent={'center'} color={currentReturn >= 0 ? "success.main" : "error.main"}>
									<Typography variant="caption" align="center"> {currentReturn || 0}% </Typography>
									<TrendingIcon value={currentReturn} fontSize="inherit" sx={{paddingLeft: 0.2, paddingTop:0.1}} />
								</Box>
								</>
							)}
						</Stack>
					</Box>
					<Box border={'1px solid rgba(0, 0, 0, 0.12)'} borderRadius={1} padding={1} height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
						<Stack >
							<Typography variant="h6" align="center"> Proventos </Typography>
							{calculatingEarnings ? (
								<Box display={'flex'} justifyContent={'center'}>
									<CircularProgress size={'1.5rem'} sx={{display: 'flex', padding: 1}}/>
								</Box>
							):(
								<>						
								<Typography variant="h6" align="center">{formatCurrency(totalEarnings)}</Typography>
								<Box display='flex' justifyContent={'center'}>
									<Typography variant="caption" align="center">{formatCurrency(monthlyEarnings)}</Typography>
								</Box>
								</>
							)}			
						</Stack>
					</Box>					
				</Stack>				
			</CardContent>		
		</Card>		
	)
}

export default SummaryCard